import { createFileRoute } from '@tanstack/react-router'
import { requireAnyPermission } from '../../app/guards'
import { REPORT_PERMISSIONS } from '../../features/reports/catalog'
import { ReportsHubPage } from '../../features/reports/reports-hub-page'

export const Route = createFileRoute('/_app/reports')({
  staticData: { crumb: 'reports' },
  beforeLoad: ({ context }) => requireAnyPermission(context.session, ...REPORT_PERMISSIONS),
  component: ReportsHubPage,
})
